if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        // CHARABANC PATCH 2026-10-16:记住当前规格的主图(服务器把它标成 is-active),setActiveMedia 用它判断「换没换图」。
        // 不能在 setActiveMedia 里现查 DOM:product-info.updateMedia 先把新规格的图(带 is-active)插进来,再调用这里。
        this.activeVariantMediaId = this.elements.viewer.querySelector('[data-media-id].is-active')?.dataset.mediaId;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        this.loadDeferredMediaImages(event.detail.currentElement);
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        // CHARABANC PATCH 2026-10-16(老板选 B):和上一次选中的主图比,区分「换了图」和「图没变」。
        const mediaChanged = this.activeVariantMediaId !== activeMedia.dataset.mediaId;
        this.activeVariantMediaId = activeMedia.dataset.mediaId;
        this.loadDeferredMediaImages(activeMedia);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // CHARABANC PATCH 2026-10-16(老板选 B)— 手机上图库在购买区上方。原逻辑每次换规格都把整页滚回大图
          // (真机 IG + Safari 复现 816px → 173px)。换容量时主图不变,跳回去只看到同一张图,还把选项推出屏幕。
          // 现在:手机上主图变了(换机型 / 刻字款换颜色)→ 照原逻辑滚回去看新图(价格同一屏);
          //       主图没变 → 只在价格被顶部导航挡住时往上挪到刚好露出价格,且刚点的选项仍留在屏幕里。电脑端不变。
          // 10-16 老板「开AB上」:只有 A/B 的 B 组(html 带 pd-mfix,实验 exp_pdp_mobilefix_20261016)走新逻辑;
          // 对照组照旧(换容量也滚回大图)。
          if (!this.mql.matches && !mediaChanged && document.documentElement.classList.contains('pd-mfix')) {
            this.revealPriceIfHidden();
            return;
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // CHARABANC PATCH 2026-10-16(老板选 B):主图没变的切换(换容量)后,价格若被顶部导航挡住,
      // 往上挪到刚好露出价格;挪动量不超过让刚点的选项(所在 fieldset,找不到就用整个规格区)离开屏幕的量。
      // 价格本来看得见、或挪了会把选项推出屏幕 → 不动。只往上挪,不往下。
      revealPriceIfHidden() {
        const info = this.closest('product-info');
        const price = info && info.querySelector(`#price-${info.dataset.section}`);
        if (!price) return;
        const header = document.querySelector('sticky-header');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const topLimit = Math.max(headerBottom, 0) + 12;
        const priceTop = price.getBoundingClientRect().top;
        if (priceTop >= topLimit) return;
        const focused = document.activeElement;
        const anchor =
          (focused && info.contains(focused) && focused.closest('fieldset')) || info.querySelector('variant-selects');
        let delta = topLimit - priceTop;
        if (anchor) {
          const room = window.innerHeight - 12 - anchor.getBoundingClientRect().bottom;
          if (room <= 0) return;
          delta = Math.min(delta, room);
        }
        if (delta < 4) return;
        window.scrollTo({ top: window.scrollY - delta, behavior: 'smooth' });
      }

      loadDeferredMediaImages(container) {
        // CHARABANC PATCH 2026-08-06 — 两个调用点里只有一个是安全的。
        // setActiveMedia 那一路有 `if (!activeMedia) return` 兜着;
        // onSlideChanged 那一路直接把 `event.detail.currentElement` 递进来,而它可能是
        // undefined —— global.js 派发 slideChanged 时取的是
        // `sliderItemsToShow[currentPage - 1]`,幻灯片宽度为 0 时 currentPage 会是 NaN。
        // 与 2026-08-04 修的公告栏空转是**同一条机制的另一个消费端**。
        // 实测近 7 天 41 次 / 20 个会话,Android 28 + 桌面 13、iPhone 0 次;
        // 不阻断购买(受影响会话里仍有人加购成功),但会中断本函数之后的图片懒加载。
        if (!container) return;
        container.querySelectorAll('img[data-charabanc-gallery-src]').forEach((image) => {
          if (image.dataset.charabancGallerySrcset) {
            image.srcset = image.dataset.charabancGallerySrcset;
            image.removeAttribute('data-charabanc-gallery-srcset');
          }
          image.src = image.dataset.charabancGallerySrc;
          image.removeAttribute('data-charabanc-gallery-src');
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
